module.exports = __webpack_public_path__ + "static/media/LineArt.b7f0c671.svg";